

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { DevicesModule } from '~/store/modules/devices';
import DumpPopupMixin from '~/mixins/dumpPopup.mixin';

@Component
export default class OperationStatsDumpPopup extends Mixins(PopupMixin, DumpPopupMixin) {
    filePrefix = 'statDump';

    get rawDumpValue() {
        return DevicesModule.statsDumpValue;
    }

    get isVerbose() {
        return this.rawDumpValue.verbose;
    }

    async getStatsDump() {
        try {
            if (DevicesModule.currentGateway) {
                const data = await DevicesModule.currentGateway.statsDumpFunction({ verbose: this.isVerbose });
                await DevicesModule.setStatsDumpValue(data);
            }
        } catch (error) {
            await DevicesModule.setStatsDumpValue({ dump: 'Error while fetching dump', verbose: this.isVerbose });
        }
    }
}
